import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import overviewDailyV2 from './pageConfig/overviewDailyV2';
import overviewWeeklyV2 from './pageConfig/overviewWeeklyV2';
import overviewMonthlyV2 from './pageConfig/overviewMonthlyV2';
import overviewDailyV3 from './pageConfig/overviewDailyV3New';
import overviewDailyV4 from './pageConfig/overviewDailyV4';
// import dl2OverviewWeeklyV2 from './pageConfig/dl2OverviewWeeklyV2';
// import dl2OverviewMonthlyV2 from './pageConfig/dl2OverviewMonthlyV2';
// import dl2OverviewDailyV2 from './pageConfig/dl2OverviewDailyV2';

interface IPageConfigMap {
  [key: string]: IPageConfigType;
}

export const PAGE_CONFIG_MAP: IPageConfigMap = {
  '/overview/daily-v2': overviewDailyV2,
  '/overview/weekly-v2': overviewWeeklyV2,
  '/overview/monthly-v2': overviewMonthlyV2,
  '/overview/daily-v3': overviewDailyV3,
  '/overview/daily-v4': overviewDailyV4,
  // Dying Light2(消逝的光芒2)，勿删
  // '/overview/daily-v2': dl2OverviewDailyV2,
  // '/overview/weekly-v2': dl2OverviewWeeklyV2,
  // '/overview/monthly-v2': dl2OverviewMonthlyV2,
};
